module.exports = __webpack_public_path__ + "static/power2-2-0f290d013c18158be2e1e14153a59641.png";